





































































import {Component, Prop, Vue} from 'vue-property-decorator'
import CourseInfo, {AnalyzedRating, CourseInfoRating, RATING_CRITERIA, UniqueCourse} from '@/logic/course-info';
import App from '@/components/app/app';
import course from '@/logic/course';
import LoadingSpinner from '@/components/loading-spinner.vue';
import loading from '@/components/overlays/loading.vue';
import StarRating from '@/components/star-rating.vue';
@Component({components: {StarRating, LoadingSpinner}})
export default class CourseDetail extends Vue
{
    @Prop({required: true}) uniqueCourse: UniqueCourse;

    detailsCourse: CourseInfo = null as any as CourseInfo
    detailsComments: CourseInfoRating[] = null as any as []

    get ratingCriteria() {return RATING_CRITERIA}
    get rating() {return this.detailsCourse.rating}

    mounted()
    {
        this.checkRatings()
    }

    updated()
    {
        this.checkRatings()
    }

    checkRatings()
    {
        // Load ratings
        this.sortedCourses.forEach(c =>
        {
            // Already has rating
            if (c.rating as any != null) return;

            // Get rating
            App.http.post('/course-info/rating/get', {condition: 'course', value: c.id_ci}).then(result =>
            {
                if (result.success)
                {
                    // Assign rating
                    c.rating = new AnalyzedRating(result.data);
                }
                else
                {
                    this.$message.error(`Rating data for ${c.name} / ${c.teacher} failed to load.`)
                    console.log(result.data);
                }
            })
        })
    }

    get sortedCourses(): CourseInfo[]
    {
        return this.uniqueCourse.courses.sort((a, b) => a.levelID - b.levelID);
    }

    openDetails(course: CourseInfo)
    {
        let c = this.detailsCourse = this.detailsCourse == course ? null as any as CourseInfo : course;

        // Load comments
        App.http.post('/course-info/rating/get', {condition: 'course-comments', value: c.id_ci}).then(result =>
        {
            if (result.success)
            {
                this.detailsComments = result.data.map((r:any) => new CourseInfoRating(r));
            }
            else
            {
                this.$message.error(`Rating data for ${c.name} / ${c.teacher} failed to load.`)
                console.log(result.data);
            }
        })

        // TODO: Finish comment section
    }

    closeDetails()
    {
        this.detailsCourse = null as any as CourseInfo;
        this.detailsComments = null as any as []
    }
}
